var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Nomore"},[_vm._v(_vm._s(_vm.$t('common.nomore')))])
}
var staticRenderFns = []

export { render, staticRenderFns }